// ============================================================
// 设备上下文 Provider（含 JSX，放在 web 应用层）
// ============================================================

import { createContext, useContext, type ReactNode } from 'react'
import { useDevice, type DeviceInfo } from '@task-bazaar/shared'

const DeviceContext = createContext<DeviceInfo | null>(null)

export function DeviceProvider({ children }: { children: ReactNode }) {
  const device = useDevice()
  return <DeviceContext.Provider value={device}>{children}</DeviceContext.Provider>
}

export function useDeviceContext(): DeviceInfo {
  const ctx = useContext(DeviceContext)
  if (!ctx) throw new Error('useDeviceContext must be used within DeviceProvider')
  return ctx
}
